import { validator } from "@/utils/validator";

export const useGetUserSettingEmailSchema = (props: { currentEmail: string }) => {
  return validator.object().shape({
    email: validator
      .string()
      .trim()
      .autoTransformToHalfWidth()
      .email()
      .max(60)
      .label("新しいメールアドレス")
      .required()
      .test((value, ctx) => {
        if (value === props.currentEmail)
          return ctx.createError({ message: "新しいメールアドレスは現在のメールアドレスと同じです。別のメールアドレスを入力してください。" });
        return true;
      }),
  });
};
